// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireConditionIsEmptyFragmentDoc } from './rules/QuestionnaireConditionIsEmpty.fragment.generated';
import { QuestionnaireConditionIsEqualToFragmentDoc } from './rules/QuestionnaireConditionIsEqualTo.fragment.generated';
import { QuestionnaireConditionIsGreaterThanFragmentDoc } from './rules/QuestionnaireConditionIsGreaterThan.fragment.generated';
import { QuestionnaireConditionIsLessThanFragmentDoc } from './rules/QuestionnaireConditionIsLessThan.fragment.generated';
import { QuestionnaireConditionIsNotEmptyFragmentDoc } from './rules/QuestionnaireConditionIsNotEmpty.fragment.generated';
import { QuestionnaireConditionNotIsEqualToFragmentDoc } from './rules/QuestionnaireConditionNotIsEqualTo.fragment.generated';
import { QuestionnaireConditionEqualToChoiceFragmentDoc } from './rules/QuestionnaireConditionChoiceEqualTo.generated';
export const QuestionnaireConditionFragmentDoc = gql`
    fragment questionnaireCondition on QuestionnaireCondition {
  __typename
  type
  rules {
    ...questionnaireConditionIsEmpty
    ...questionnaireConditionIsEqualTo
    ...questionnaireConditionIsGreaterThan
    ...questionnaireConditionIsLessThan
    ...questionnaireConditionIsNotEmpty
    ...questionnaireConditionNotIsEqualTo
    ...questionnaireConditionEqualToChoice
  }
}
    ${QuestionnaireConditionIsEmptyFragmentDoc}
${QuestionnaireConditionIsEqualToFragmentDoc}
${QuestionnaireConditionIsGreaterThanFragmentDoc}
${QuestionnaireConditionIsLessThanFragmentDoc}
${QuestionnaireConditionIsNotEmptyFragmentDoc}
${QuestionnaireConditionNotIsEqualToFragmentDoc}
${QuestionnaireConditionEqualToChoiceFragmentDoc}`;